
import gql from 'graphql-tag';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import travelTooltips from '~/apollo/queries/product/tooltips/travelTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import travelRegionsQuery from '@/apollo/queries/product/travelRegions'
import userFavProductTravel from '@/apollo/queries/user/userFavProductTravel'
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'ProductsHomeListingPage',
  mixins: [commonProductMixins, productPromotionMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    travelScenarios: {
      query: gql`
        ${userFavProductTravel}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        console.debug(returnObj);

        return returnObj;
      }
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      // variables() {
      //   return {
      //     show_home: true,
      //   };
      // },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          return {
            value: item.attributes.code,
            text:
              item.attributes.insurance_company_translations.data[0].attributes.name +
              ' | ' +
              item.attributes.insurance_company_translations.data[1].attributes.name,
          };
        });
      },
    },
    travelRegions: {
      query: travelRegionsQuery,
      prefetch: true,
      variables() {
        let tmpLocale;
        tmpLocale = undefined;
        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        return {
          locale: tmpLocale,
        };
      }
    },
    travelTooltips: {
        query: travelTooltips,
        prefetch: true,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.infoTooltip.data);
        },
      },
  },
  props: {
    productId: String,
    params: String,
    favProductId: String,
  },
  data() {
    return {
      travelScenarios: Object,
      productLoading: 0,
      currentLink: "",
      loading: 0
    };
  },
  
  computed: {
    mainQueryLoading() {
      return this.$apollo.queries.travelScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.travel.td_result').replace('$num', '{ }');
      } else {
        return this.$t('products.travel.td_result').replace('$num', this.rows);
      }
    },

    displayProduct(){
      if (this.simpleItem) {
        const item = this.simpleItem;
        const featureArray = [];
        if (item.mobile_phone_protection) {
          featureArray.push({
            text: this.$t('products.travel.td_mobile_protection'),
            type: 'mobile'
          })
        }
        if (item.follow_up_physiotherapy) {
          featureArray.push({
            text: this.$t('products.travel.td_physio'),
            type: 'physio'
          })
        };
        if (item.car_rental_excess) {
          featureArray.push({
            text: this.$t('products.travel.td_car_rental'),
            type: 'car_rental'
          })
        };
        if (item.extreme_sports_medical) {
          featureArray.push({
            text: this.$t('products.travel.td_extreme_sports'),
            type: 'extreme_sport'
          })
        };
        if (item.loss_of_travel_document) {
          featureArray.push({
            text: this.$t('products.travel.td_loss_travel_doc'),
            type: 'loss_travel_doc'
          })
        };
        let premiumDay;
        if (this.simpleParams.duration < 10) {
          premiumDay = 'premium' + '0' + this.simpleParams.duration;
        } else if (this.simpleParams.duration >= 10 && this.simpleParams.duration <= 31) {
          premiumDay = 'premium' + this.simpleParams.duration;
        } else if (this.simpleParams.duration > 31) {
          premiumDay = 'premium31';
        }
        return {
          id: item.scenario_code,
          productType: 'travel',
          category: this.category,
          scenarioId: item.scenarioID,
          showFiveStarBadge: false,
          showTrending: false,
          showCTA: item.show_cta,
          productLink: this.$extendPath(
            '/products/travel',
            '/' +
              item.scenario_code +
            '?' +
            this.params
          ),
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo,
            logoAlt: item.insurer_name_first,
          },
          // userRating: {
          //   score: item.overall_star,
          //   numberOfRatedUser: '0',
          // },
          tenlifeScore: {
            score: parseFloat(this.getScore(item)),
            description: this.$t('products.travel.td_overall_score'),
            toolTipHtml: this.getTooltipContentByKey("tr_overallScore"),
          },
          features: featureArray,
          keyItems: [
            {
              value: this.$formatScore(item.medical_emergency_score) + ' / 10',
              key: this.$t('products.travel.td_medical_emergency_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey("tr_medicalEmergencyScore"),
              symbolValue: '',
              originalValue: '',
              isTextBlack: true
            },
            {
              value: this.$formatScore(item.accident_score) + ' / 10',
              key: this.$t('products.travel.td_accident_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey("tr_accidentScore"),
              symbolValue: '',
              originalValue: '',
              isTextBlack: true
            },
            {
              value: this.$formatScore(item.inconv_score) + ' / 10',
              key: this.$t('products.travel.td_inconv_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey("tr_inconvenienceScore"),
              symbolValue: '',
              originalValue: '',
              isTextBlack: true
            },
            {
              value: this.$formatScore(item.personal_property_score) + ' / 10',
              key: this.$t('products.travel.td_property_score'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey("tr_propertyScore"),
              symbolValue: '',
              originalValue: '',
              isTextBlack: true
            },
          ],
          compactKeyItems: [
            {
            // value: item.promotion_prices[0]
            //   ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
            //   : this.$formatPrice(item.premium),
            value: item.promotion_price
            ? parseInt(item.promotion_price).toLocaleString('en-US')
            : item?.premium[premiumDay] ? this.$formatPrice(item.premium[premiumDay]) : '',
            // value: this.$formatPrice(premium),
            key: this.$t('products.travel.td_adult_premium'),
            topSubText: 'HKD',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: item.promotion_price
            ? item?.premium[premiumDay] ? this.$formatPrice(item.premium[premiumDay]) : ''
            : '',
            },
          ],
          promotion: {
            category:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioID,
            hide: item.hide,
            noPopup: item.noPopup,
            lastCall: item.promotion_last_call
          },
          // mainButtonCTA: {
          //   text: item.decoder_cta_text,
          //   link: item.decoder_cta_link,
          // },
          mainButtonCTA: item.main_cta,
          price: {
            // originalPrice: item.promotion_prices[0] ? this.$formatPrice(item.premium) : '',
            // originalPrice: this.$formatPrice(item.premium),
            // originalPrice: this.$formatPrice(premium),
            originalPrice: item.promotion_price
            ? item?.premium[premiumDay] ? this.$formatPrice(item.premium[premiumDay]) : ''
            : '',
            discountPrice: item.promotion_price
            ? parseInt(item.promotion_price).toLocaleString('en-US') 
            : item.premium[premiumDay]? this.$formatPrice(item.premium[premiumDay]) : '',
            // discountPrice: item.promotion_prices[0]
            //   ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
            //   : this.$formatPrice(item.premium),
            prefix: "HKD",
            postfix: '',
            subText: this.$t('products.travel.td_adult_premium'),
            toolTipHtml: this.getTooltipContentByKey("tr_adult"),
          }
        }
      }
      return null;
    },

    simpleItem() {
      if(!this.loading) {
        if (this.travelScenarios ) {
          return this.travelScenarios.data.map((item) => {
            const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name
            // let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), planName);
            // let decoderCTAText = this.$t('products.purchase_now');
  
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;
  
            let promotionPrice = null;
  
            let hide = Boolean;
            hide = false;
            let noPopup = Boolean;
            noPopup = false;
  
            let decoderCTALink = '';
            let decoderCTAText = '';
            let mainCTA = this.getDecoderCTA(item, decoderCTALink);
  
            // check scenario level promo first , then plan level promotion 
            if (item.attributes?.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.travel_plan.data.attributes?.product_promotions?.data?.length > 0) {
              promotions = item.attributes.travel_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);
  
              if (!promotion) {
                promotion = null;
              } else { 
                if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink =
                    promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');
                  
                  mainCTA = this.getDecoderCTA(item, decoderCTALink)
                }
                const discounts = promotion.attributes.DiscountPercentage;
                if (discounts) {
                  // calculate promotion price and avg premium
                  let premiumDay;
                  if (this.simpleParams.duration < 10) {
                    premiumDay = 'premium' + '0' + this.simpleParams.duration;
                  } else if (this.simpleParams.duration >= 10 && this.simpleParams.duration <= 31) {
                    premiumDay = 'premium' + this.simpleParams.duration;
                  } else if (this.simpleParams.duration > 31) {
                    premiumDay = 'premium31';
                  }
                  const originalPrice = item.attributes.travel_premiums.data[0]?.attributes[premiumDay];
                  if(discounts.Year1 !== 0)
                    promotionPrice = originalPrice * (100 - discounts.Year1) / 100;
                }
  
                const translation = promotion.attributes.product_promotion_translations?.data[0];
                hide = translation?.attributes?.HideBanner;
                noPopup = translation?.attributes?.NoPopup??false;
              }
            }
  
            // const salesLink = mainCTA.link.includes(process.env.SALES_EXTERNAL_URL)
            //     ? mainCTA.link + (promotion?.id ? '&promotionId=' + promotion?.id : '')
            //     : mainCTA.link;
            //   mainCTA.link = salesLink;
            //   CTAButtonLink = mainCTA.link;
            //   CTAButtonText = mainCTA.text;
  
            //   const translation = promotion.attributes.product_promotion_translations?.data[0];
            //   hide = translation?.attributes?.HideBanner;

            const filteredTranslations = this.getFilteredTranslations(item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              // plan 
              plan_code: item.attributes.plan_code,
              scenario_code: item.attributes.scenario_code,
              scenarioID: item.id,
              plan_name: planName,
              accident_score: item.attributes.travel_plan.data.attributes.accident_score,
              inconv_score: item.attributes.travel_plan.data.attributes.inconv_score,
              medical_emergency_score: item.attributes.travel_plan.data.attributes.medical_emergency_score,
              personal_property_score: item.attributes.travel_plan.data.attributes.property_score,
              overall_score: item.attributes.travel_plan.data.attributes.overall_score,
              saleable: item.attributes.travel_plan.data.attributes.saleable,
              show_cta: item.attributes.show_cta,
  
              // // feature
              mobile_phone_protection: item.attributes.travel_plan.data.attributes.mobile_phone_protection,
              follow_up_physiotherapy: item.attributes.travel_plan.data.attributes.follow_up_physiotherapy,
              car_rental_excess: item.attributes.travel_plan.data.attributes.car_rental_excess,
              extreme_sports_medical: item.attributes.travel_plan.data.attributes.extreme_sports_medical,
              loss_of_travel_document: item.attributes.travel_plan.data.attributes.loss_of_travel_document,
  
              // insurer 
              insurer_name_first:
                item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
              insurer_name_second:
                filteredTranslations[0].attributes.name,
              insurer_logo:
                item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo.data.attributes.url,
  
              insurer_code:
                item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,
  
              // // premium
              premium: item.attributes.travel_premiums.data[0]?.attributes,
              decoder_cta_text: decoderCTAText,
              decoder_cta_link: decoderCTALink,
  
              product_promotion: promotion,
              promotion_price: promotionPrice,
              promotion_last_call: promotion_last_call,
  
  
              hide,
              noPopup,
              
              main_cta: mainCTA
            }
          })[0];
        }

      }
      return null;
    },
    simpleGeoRegions() {
      const GeoRegions = [{ value: '-1', text: this.$t('products.any') }];
      const tmpRegion = this.travelRegions?.data.map((item) => {
        return {
          value: item.attributes.travel_region_translations.data[0].attributes.code,
          text: item.attributes.travel_region_translations.data[0].attributes.description
        }
      })
      return tmpRegion ? tmpRegion.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0)) : GeoRegions;
      // return tmpRegion ? GeoRegions.concat(tmpRegion) : GeoRegions;
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split('=');
        vars[params[0]] = params[1];
      }

      if (!vars.duration)
      {
        vars.duration = 1;
      }
      return vars;
    },
  },

  watch: {
    travelScenarios() {
      console.debug(this.travelScenarios.data);
      if (this.travelScenarios.data.length) {
        this.$emit("product-load", 'Travel');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  updated() {
    if (this.simpleItem) {
      this.$emit('productTitle', {
        id: this.favProductId,
        companyName: this.simpleItem.insurer_name_first,
        title: this.simpleItem.plan_name,
      });
    }
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.geoRegionValue',
        filterOptionsPath: 'simpleGeoRegions',
        queryKey: 'geo[]',
        defaultValue: ['japan'],
        ignoreFix: true,
        type: 'array',
      },

      {
        filterValuePath: 'filter.featureTypeValue',
        filterOptionsPath: 'filter.featureTypeValue',
        queryKey: 'featuretype[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingData.sortingOptions',
        queryKey: 'sort',
        defaultValue: 'overall_score',
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      // {
      //   filterValuePath: 'filter.ownerTypeValue',
      //   filterOptionsPath: 'filter.ownerTypeOptions',
      //   queryKey: 'ownerType',
      //   defaultValue: 'O',
      // },
      // {
      //   filterValuePath: 'filter.propertyTypeValue',
      //   filterOptionsPath: 'filter.propertyTypeOptions',
      //   queryKey: 'propertyType',
      //   defaultValue: 'MB',
      // },
      // {
      //   filterValuePath: 'filter.buildingAgeValue',
      //   queryKey: 'propertyAge',
      //   defaultValue: '35',
      //   ignoreFix: true,
      //   type: 'input',
      // },
      // {
      //   filterValuePath: 'filter.grossAreaValue',
      //   queryKey: 'grossArea',
      //   defaultValue: '750',
      //   ignoreFix: true,
      //   type: 'input',
      // },
      // {
      //   filterValuePath: 'filter.planTypeValue',
      //   filterOptionsPath: 'filter.planTypeOptions',
      //   queryKey: 'planType',
      //   defaultValue: 'basic',
      // },


    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);
  },

  mounted() {
    const insurerfilterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };

    this.fixFilterArrayValueDueToQueryString(insurerfilterArrayValueToFix);

    const geofilterArrayValueToFix = {
      filterValuePath: 'filter.geoRegionValue',
      filterOptionsPath: 'simpleGeoRegions',
      queryKey: 'geo[]',
    };

    this.fixFilterArrayValueDueToQueryString(geofilterArrayValueToFix);

    const featurefilterArrayValueToFix = {
      filterValuePath: 'filter.featureTypeValue',
      filterOptionsPath: 'filter.featureTypeOptions',
      queryKey: 'featuretype[]',
    };
    // console.log(this.$route.query, 'query')
    this.fixFilterArrayValueDueToQueryString(featurefilterArrayValueToFix);

    this.currentLink = window.location.href;
  },

  methods: {
    getDate(date) {
      // console.log(date[0], date[1])
      if (date.length > 1) {
        const lastDate = this.parseDate(date[1]);
        const firstDate = this.parseDate(date[0]);
        const dateRangeDiff = Math.round((lastDate - firstDate) / (1000 * 60 * 60 * 24));
        // this.simpleParams.dateRange = dateRangeDiff;
        // console.log(Math.round((lastDate - firstDate) / (1000 * 60 * 60 * 24)) + 1)
      }
    },
    parseDate(date) {
      const ydm = date.split('-');
      // console.log(ydm)
      return new Date(ydm[0], ydm[1], ydm[2]);
    },
    getScore(product) {
      // console.log(product);
      return product.overall_score.toFixed(1);
    },
  
    getTooltipContentByKey(mKey) {
        return this.travelTooltips?.Travel?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getDecoderCTA(item, promotionCTALink) {
        const planName = item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.name;
        const insurer = item.attributes.travel_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
        const link = this.currentLink;
        const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.travel.td_categoryName'), insurer, planName, { link: link });
        const showCTA = item.attributes.show_cta;
        const saleable = item.attributes.travel_plan.data.attributes.saleable;
        const productWebsite =
          item.attributes.travel_plan.data.attributes.travel_plan_translations.data[0].attributes.product_website;
        
        if (!showCTA) return null;
  
        if (saleable) {
          return {
            text: this.$t('products.purchase_now'),
            link:
              process.env.SALES_EXTERNAL_URL +
              '/' +
              (this.currentLocale === 'en' ? 'en' : 'tc') +
              '/purchase?id=' +
              item.attributes.scenario_code
          };
        } else if (promotionCTALink) {
          return {
            text: this.$t('products.purchase_now'),
            link: promotionCTALink,
          };
        } else if (productWebsite) {
          return {
            text: this.$t('products.product_website'),
            link: productWebsite,
            type: 'product-website',
          };
        } else {
          return {
            text: '',
            link: decoderCTAWhatsappLink,
          };
        }
      },
  }
}
